import { Navigate } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const MyTaskListLayout = lazyRoute(() => import("./my-task-list/my-task-list.layout"), "MyTaskListLayout");
const MyTaskListPage = lazyRoute(() => import("./my-task-list/my-task-list.page"), "MyTaskListPage");
const MyTaskListBoardPage = lazyRoute(() => import("./my-task-list/my-task-list-board.page"), "MyTaskListBoardPage");
const TaskLayout = lazyRoute(() => import("./task-list/$taskId/task.layout"), "TaskLayout");
const TaskPage = lazyRoute(() => import("./task-list/$taskId/task.page"), "TaskPage");
const TaskDetailTabPage = lazyRoute(() => import("./task-list/$taskId/task-detail-tab.page"), "TaskDetailTabPage");
const TaskTrashPage = lazyRoute(() => import("@/domain/trash/routes/task-trash.page"), "TaskTrashPage");

export const myTasksRoutes = [
  {
    path: "my-tasks",
    element: <MyTaskListLayout />,
    children: [
      {
        path: "",
        element: <MyTaskListPage />,
      },
      {
        path: "board",
        element: (
          <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to=".." replace />}>
            <MyTaskListBoardPage />
          </FeatureFlagToggle>
        ),
      },
      {
        path: "trash",
        element: <TaskTrashPage />,
      },
    ],
  },
];

export const taskRoutes = [
  {
    path: "tasks",
    children: [
      {
        path: ":taskId",
        element: <TaskLayout />,
        children: [
          {
            path: "",
            element: <TaskPage />,
            children: [
              { path: "", element: <Navigate to="details" replace /> },
              { path: "details", element: <TaskDetailTabPage /> },
            ],
          },
        ],
      },
    ],
  },
];
